import { createFileRoute } from "@tanstack/react-router";

import { LiveGeographicCanvas } from "@/components/canvas/live-geographic-canvas";

export const Route = createFileRoute("/$workspace/geographic")({
  head: () => ({ meta: [{ title: "Geographic — Dravian Horizon" }] }),
  component: GeographicPage,
});

function GeographicPage() {
  const { workspace } = Route.useParams();
  return <LiveGeographicCanvas workspaceId={workspace} />;
}
